<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">New Round</div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/playoffs" v-bind:exact="exact">Playoffs</v-breadcrumbs-item>
                        <v-breadcrumbs-item style to="/admin/playoffs/new_round" v-bind:exact="exact">New Round</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-select
                                    v-model="seasonId"
                                    v-bind:items="seasons"
                                    label="Season"
                                    required
                                ></v-select>
                                <v-text-field label="Round" v-model="round" mask="###"></v-text-field>
                                <v-text-field label="Round Title" v-model="roundTitle"></v-text-field>
                                <v-text-field
                                    label="Best Of"
                                    v-model="bestOf"
                                    mask="###"
                                    v-bind:rules="bestOfRules"
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Create Round</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'AdminPlayoffsRoundNew',
    data() {
        return {
            exact: true,
            valid: false,
            seasonId: '',
            round: 1,
            roundTitle: 'Round 1',
            bestOf: 3,
            bestOfRules: [(v) => parseInt(v) % 2 === 1 || 'Best Of must be an odd number.']
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('createPlayoffRound', {
                    round: this.round,
                    round_title: this.roundTitle,
                    best_of: this.bestOf,
                    season_id: this.seasonId
                })
            }
        }
    },
    computed: {
        seasons() {
            return this.$store.state.seasons
                .map((season) => {
                    return { text: season.season, value: season.id }
                })
                .sort((a, b) => {
                    if (a.text > b.text) {
                        return -1
                    } else if (a.text < b.text) {
                        return 1
                    } else {
                        return 0
                    }
                })
        }
    },
    mounted() {
        if (this.$store.state.currentSeason) {
            this.seasonId = this.$store.state.selectedSeason.id

            if (this.$store.state.playoffRounds.length > 0) {
                let nextRoundNumber = 0
                this.$store.state.playoffRounds.forEach((round) => {
                    if (round.season_id === this.seasonId) {
                        if (nextRoundNumber < round.round) {
                            nextRoundNumber = round.round
                        }
                    }
                })
                this.round = nextRoundNumber += 1
                this.roundTitle = `Round ${nextRoundNumber}`
            }
        }
    }
}
</script>

<style scoped>
</style>
